// extracted by mini-css-extract-plugin
module.exports = {"wrap":"building-event_wrap_3jGK3"};